"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleTypeCoefficient = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
let VehicleTypeCoefficient = class VehicleTypeCoefficient {
    vehicleType;
    priceAdjustmentCoefficient;
    feeAdjustmentCoefficient;
    cutoffInHours;
};
exports.VehicleTypeCoefficient = VehicleTypeCoefficient;
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.VehicleType),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(() => type_graphql_1.Int),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Number)
], VehicleTypeCoefficient.prototype, "vehicleType", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Number)
], VehicleTypeCoefficient.prototype, "priceAdjustmentCoefficient", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Number)
], VehicleTypeCoefficient.prototype, "feeAdjustmentCoefficient", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Number)
], VehicleTypeCoefficient.prototype, "cutoffInHours", void 0);
exports.VehicleTypeCoefficient = VehicleTypeCoefficient = __decorate([
    (0, type_graphql_1.ObjectType)("SimpleVehicleTypeCoefficient"),
    (0, type_graphql_1.InputType)("SimpleVehicleTypeCoefficientInput")
], VehicleTypeCoefficient);
//# sourceMappingURL=VehicleTypeCoefficient.js.map